export default "__VITE_ASSET__DZ5_y3eN__"